module.exports = __webpack_public_path__ + "img/murallas.50f2c9a8.png";